import { AfterViewInit, Component, OnDestroy } from '@angular/core';

import { ParentEvents } from '../utils/parent-events.service';

@Component({
    template: ``,
})
export abstract class BaseUI implements AfterViewInit, OnDestroy {
    protected constructor(protected parentEvents: ParentEvents) {}

    ngAfterViewInit() {
        this.parentEvents.resize();
    }

    ngOnDestroy() {
        this.parentEvents.resize();
    }
}
